export default __webpack_public_path__ + "static/media/samandehi.d9c34c17.png";